import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiBaseurlInterceptor implements HttpInterceptor {
    private readonly exclusions = ['assets', this.env['TPS_AUTH_URL']];
    constructor(@Inject('ENV') private env) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.exclusions.some((exclusion) => request.url.includes(exclusion))) {
            return next.handle(request);
        }

        if (request.url.startsWith('http')) {
            return next.handle(request);
        }

        const baseUrl: string = this.env['PAYMENTS_PORTAL_API'] ?? '';
        const url = `${baseUrl}${request.url}`;
        return next.handle(request.clone({ url }));
    }
}
